import { createSlice } from '@reduxjs/toolkit'

let initState = {
    isLoading: false,
    isDeleted: false,
    project: {},
    config: {},
    users: []
}

try { initState.project = localStorage.project ? JSON.parse(localStorage.project) : {} } catch(err) { console.log("Failed to init project", err); localStorage.setItem('project', JSON.stringify({}))  }
try { initState.config = localStorage.config ? JSON.parse(localStorage.config) : {} } catch(err) { console.log("Failed to init config", err); localStorage.setItem('config', JSON.stringify({})) }
try { initState.users = localStorage.users ? JSON.parse(localStorage.users) : [] } catch(err) { console.log("Failed to init users", err); localStorage.setItem('users', JSON.stringify([]))  }

export const pscStateSlice = createSlice({
    name: 'pscState',
    initialState: {
        value: initState
    },
    reducers: {
        setProject: (state, action) => {
            state.value.project = action.payload
            localStorage.setItem('project', JSON.stringify(action.payload));
        },
        clearProject: state => {
            delete state.value.project;
            localStorage.removeItem('project');
        },
        setIsLoading: (state, action) => {
            state.value.isLoading = action.payload
        },
        setIsDeleted: (state, action) => {
            state.value.isDeleted = action.payload
        },
        setConfig: (state, action) => {
            state.value.config = action.payload
            localStorage.setItem('config', JSON.stringify(action.payload));
        },
        setUsers: (state, action) => {
            state.value.users = action.payload
            localStorage.setItem('users', JSON.stringify(action.payload));
        },
    }
})

export const { setProject, clearProject, setIsLoading, setIsDeleted, setConfig, setUsers } = pscStateSlice.actions
export default pscStateSlice.reducer
